import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as survey from '../survey'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: survey.RESOURCE.payload.dimension.partialId,
      partialId: survey.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'Space Lite survey status',
    isOptional: true,
    name: 'Status Lite',
    partialId: PartialId.Standard.create('status_lite'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.spaceSurveyStatus.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
